import { Dialog } from 'primereact/dialog';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Toast } from 'reactstrap';
import ExhibitonTopbar from './ExhibitonTopbar';
import { Colors } from 'chart.js';
import { Button } from 'primereact/button';
import FileService from '../../service/FileService';
import { FileUpload } from 'primereact/fileupload';
import { OverlayPanel } from 'primereact/overlaypanel';
import Constants from '../../constants/Constants';


export const SelectedExhibitionPage = (props) => {

    console.log("SelectedExhibitionPage", props)
    const { t } = useTranslation();

    const opInfo = useRef(null);
    const [showInfo, setShowInfo] = useState(false);


    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const RenderContent = () => {
        return (

            <div className="grid align-items-end  justify-content-center " style={{}}>

                {props.index % 2 === 0 &&
                    <>


                        <div className='text-center col-12 md:col-7 pr-5 ' >

                            <RenderImage />


                        </div>
                        <div className="col-12 md:col-5 align-items-start pr-5 " >

                            <RenderContentInfo />
                        </div>
                    </>
                }
                {props.index % 2 != 0 &&
                    <>


                        <div className='text-right col-12 md:col-5  pr-5 ' >

                            <RenderContentInfo />


                        </div>
                        <div className="col-12 md:col-7 align-items-start pr-5 " >
                            <RenderImage />

                        </div>
                    </>
                }


            </div>





        );
    };

    const RenderImage = () => {
        return (<div className='exhibition-images' style={{
            backgroundImage: `url(${FileService.inquireFilePath(props?.artwork?.file)})`,
        }}
            onClick={
                () => {
                    // props.onAction?props.onAction(props.artworks[index]): selectedArtworks(index)

                }
            } />
        )
    }

    const RenderContentInfo = () => {
        return (
            <div id="content_info_div">
                <span className="block text-6xl  mb-1" style={{ color: '#F7F7F7' }}>
                    {props?.artwork?.name}
                </span>
                <span className="block text-1xl  mb-1 " style={{ color: '#F7F7F7' }}>
                    {props?.artwork?.descr}
                </span>

                <div className='  mt-2  ' style={{ color: '#F7F7F7' }}>
                    <Button icon="fa-regular fa-heart" className={props?.artwork?.favoriteId ? "p-button-rounded mr-2 mb-2  " : "p-button-rounded p-button-light mr-2 mb-2"}
                        onClick={() => {
                            if (props?.artwork?.favoriteId)
                                props.onRemoveFavorite(props?.artwork?.favoriteId,props?.artwork);
                            else
                                props.onAddFavorite(Constants.entityNames.artwork,props?.artwork)
                        }}
                    />
                    <Button className="p-button-rounded p-button-light mr-2 mb-2" label={props?.artwork?.ownerName} disabled
                        onClick={() => { props.addSelectedArtworks(1) }}
                    />
                    <Button className="p-button-rounded p-button-light mr-2 mb-2" label={t("technical_info")}
                        onClick={(e) => {
                            setShowInfo(true);
                            //opInfo.current.toggle(e);

                            console.log("technical_info")
                        }}
                    />
                    <Button icon="fas fa-trash" className="p-button-rounded p-button-light mr-2 mb-2"
                        onClick={() => { props.removeSelectedArtworks(props?.artwork) }}
                    />
                    <Button icon="fas fa-chevron-down" className="p-button-rounded p-button-light mr-2 mb-2"
                        onClick={() => { props.downSelectedArtworks(props?.artwork) }}
                    />
                    <Button icon="fas fa-chevron-up" className="p-button-rounded p-button-light mr-2 mb-2"
                        onClick={() => { props.upSelectedArtworks(props?.artwork) }}
                    />
                </div>

                {artworkInfoPanel()}
            </div>
        )
    }
    const artworkInfoPanel = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={showInfo}
                onHide={() => setShowInfo(false)} className={'artinfo-dialog'} headerClassName='artinfo-dialog-header'
                headerStyle={{ alignSelf: props.index % 2 === 0 ? 'flex-end' : 'center' }}
                contentClassName='artinfo-dialog-content'
            >
                <div className="grid align-items-end  justify-content-center " >

                    {props.index % 2 === 0 &&
                        <>
                            <div className='text-center col-12 md:col-7 pr-5 ' >
                            </div>
                            <div className="col-12 md:col-5 align-items-start pr-8" >

                                {artworkInfoLayer()}
                            </div>
                        </>
                    }
                    {props.index % 2 != 0 &&
                        <>


                            <div className='text-right col-12 md:col-5  pr-5 pl-8' >

                                {artworkInfoLayer()}


                            </div>
                            <div className="col-12 md:col-7 align-items-start pr-5 " >

                            </div>
                        </>
                    }
                </div>


            </Dialog>

        )


    }

    const artworkInfoLayer = () => {
        return (
            <div>
                <span className="block text-6xl  mb-1" style={{ color: '#000000' }}>
                    {props?.artwork?.name}
                </span>
                <span className="block text-1xl  mb-1 " style={{ color: '#000000' }}>
                    {props?.artwork?.descr}
                </span>

                <div className='  mt-2  ' style={{ color: '#000000' }}>
                    <Button icon="fa-regular fa-heart" className={props?.artwork?.favoriteId ? "p-button-rounded mr-2 mb-2  " : "p-button-rounded p-button-light mr-2 mb-2"} disabled
                    />
                    <Button className="p-button-rounded p-button-light mr-2 mb-2" label={props?.artwork?.ownerName} disabled
                    />
                    <Button className="p-button-rounded p-button-dark mr-2 mb-2" label={t("technical_info")} disabled
                    />
                </div>
                <div className="col-12 md:col-12 flex justify-content-between align-items-start text-left " >
                    <div className="register-content w-12  p-3">
                        <div className='grid'>
                            {props?.artwork?.artYear &&
                                <div className="col-12 md:col-6" style={{
                                    wordWrap: 'break-word',
                                    paddingBottom: 5,
                                }}>
                                    {t("global_artwork_createdate") + ": " + props?.artwork?.artYear}
                                </div>
                            }
                            {props?.artwork?.artType &&
                                <div className="col-12 md:col-6" style={{
                                    wordWrap: 'break-word',
                                    paddingBottom: 5,
                                }}>
                                    {t("global_artwork_" + props?.artwork?.artType)}
                                </div>
                            }
                            {props?.artwork?.artWidth && props?.artwork?.artHeight &&
                                <div className="col-12 md:col-6" style={{
                                    wordWrap: 'break-word',
                                    paddingBottom: 5,
                                }}>
                                    {t("global_artwork_measure") + ": " + props?.artwork?.artWidth}x{props?.artwork?.artHeight}  {t("global_artwork_" + props?.artwork?.measureUnit)}
                                </div>
                            }
                            {props?.artwork?.material &&
                                <div className="col-12 md:col-6" style={{
                                    wordWrap: 'break-word',
                                    paddingBottom: 5,
                                }}>
                                    {t("global_artwork_material") + ": " + props?.artwork?.material}
                                </div>
                            }
                        </div>
                    </div>
                </div>

            </div>

        )
    }



    const RenderContentNavigation = () => {
        return (

            <div className="flex flex-row align-items-top justify-content-end w-12 hide-scroolbar" style={{
                position: "absolute",
                top: 0,
                right: 0,
                marginTop: 20,

            }} >

                <div className="flex flex-column align-items-end  justify-content-center  w-6" style={{}}>
                    <Button icon="fas fa-angle-up" className="p-button-rounded p-button-text mr-2 text-align-center  text-white " style={{ zIndex: 999 }}
                        onClick={() => {
                            console.log("handlePageChange index", props.index);
                            props.handlePageChange((props.index))
                        }}
                    />
                    <div className=' mr-3 text-white'>
                        {props?.selectedIndex + '/' + props?.selectedCount}
                    </div>
                    <Button icon="fas fa-angle-down" className="p-button-rounded  p-button-text mr-2 text-align-center  text-white" style={{ zIndex: 999 }}
                        onClick={() => { props.handlePageChange(props.index + 2) }}
                    />
                </div>
            </div>

        );
    };


    return (
        <div className='surface-profile-header' key={"select_exhibition_" + props.key} style={{ backgroundColor: "#1C1C1C", height: "100vh" }}>
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>
            <div className='root-exhibiton' style={{}}>

                <div className="grid grid-nogutter surface-profile-main text-800"


                >

                    <div className="surface-exhibiton h-screen" >

                        {RenderContentNavigation()}
                        {RenderContent()}
                    </div>

                </div>
            </div>
        </div>
    );
}